import GroupBranchTable from "./groupBranchTable.container";

export default GroupBranchTable;
